module.exports = __webpack_public_path__ + "media/components/lessons/statics/lesson1-d781d7c2ad2a3e1d65e1c3a29e9f0c61.png";